riot.tag2('offers-event-delegator-wrapper', '<yield></yield>', '', '', function(opts) {
    const self = this;

    self.mixin('bus');

    function specialDetailsClickHandler(e) {
      e.preventDefault();

      self.bus.trigger(self.bus.EVENTS.MODAL.MODAL_OPEN_RAQ, {
        url: self.getLabel('ctas.specialDetailsRAQ')[0].url,
        event: e,
      });
    }

    const raqCTASelector = self.ctas.specialDetailsRAQ
      ? self.getLabel('ctas.specialDetailsRAQ')[0].style : null;

    const specialDetailsEventMap = [
      {
        selector: `[class="${raqCTASelector}"]`,
        event: 'click',
        fn: specialDetailsClickHandler,
      },
    ];

    function handleModalLoaded(data) {
      if (data
        && data.event
        && data.event.item
        && data.event.item.offer
        && self.getLabel('specialTypes').indexOf(data.event.item.offer.SalesProgramType) !== -1) {
        if (raqCTASelector) {
          self.modalEventMap = specialDetailsEventMap;

          self.update();
        }
      } else {
        self.modalEventMap = null;
      }
    }

    function handleOpenRAQ(data) {
      if (self.config && self.config.enableModal) {
        self.bus.trigger(self.bus.EVENTS.MODAL.MODAL_OPEN, {
          url: data.url,
        });
      }
    }

    self.on('mount', () => {
      self.ready = true;
      self.update();
    });

    self.bus.on(self.bus.EVENTS.MODAL.MODAL_OPEN_RAQ, handleOpenRAQ);
    self.bus.on(self.bus.EVENTS.MODAL.MODAL_LOADED, handleModalLoaded);
});
